import { useNavigate } from 'react-router-dom';
import { SEO } from '../seo/SEO';
import { useI18n } from '../i18n';
import { useRoutes } from '../hooks/useRoutes';
import { useSmartBack } from '../hooks/useSmartBack';
import { AppHeader } from '../components/AppHeader';
import './HubPage.css';

interface HubTile {
  key: string;
  title: string;
  desc: string;
  icon: React.ReactNode;
  accent: string;
  to: string;
}

export function ShopPage() {
  const navigate = useNavigate();
  const { r } = useRoutes();
  const smartBack = useSmartBack(r('home'));
  const { t } = useI18n();
  const s = (t as any).shopHub ?? {};

  const tiles: HubTile[] = [
    {
      key: 'premium',
      title: s.premium ?? 'Premium',
      desc: s.premiumDesc ?? '',
      accent: '#C9A66B',
      to: r('premium'),
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 2l2.4 5 5.6.8-4 3.9.9 5.6L12 14.8 7.1 17.3 8 11.7 4 7.8 9.6 7z"/>
        </svg>
      ),
    },
    {
      key: 'battlepass',
      title: s.battlepass ?? 'Battle Pass',
      desc: s.battlepassDesc ?? '',
      accent: '#D9C28F',
      to: '/battlepass',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <path d="M5 3h14l-2 7 2 11-9-4-9 4 2-11z"/>
        </svg>
      ),
    },
    {
      key: 'wallet',
      title: s.wallet ?? 'Cüzdan',
      desc: s.walletDesc ?? '',
      accent: '#A8C2A6',
      to: '/wallet',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="6" width="18" height="14" rx="2"/>
          <path d="M3 10h18M16 14h2"/>
        </svg>
      ),
    },
  ];

  return (
    <div className="hub-page">
      <SEO path="/magaza" />
      <AppHeader title={s.title ?? 'Mağaza'} onBack={smartBack} />
      <p className="hub-subtitle">{s.subtitle ?? ''}</p>
      <div className="hub-grid">
        {tiles.map(tile => (
          <button
            key={tile.key}
            type="button"
            className="hub-tile"
            style={{ ['--accent' as any]: tile.accent }}
            onClick={() => navigate(tile.to)}
          >
            <div className="hub-tile-icon" aria-hidden="true">{tile.icon}</div>
            <div className="hub-tile-text">
              <span className="hub-tile-title">{tile.title}</span>
              <span className="hub-tile-desc">{tile.desc}</span>
            </div>
            <span className="hub-tile-arr" aria-hidden="true">→</span>
          </button>
        ))}
      </div>
    </div>
  );
}
